module.exports = __webpack_public_path__ + "static/media/header_profile.835cba38.jpg";